let setLoadingFunc = null;
let activeRequests = 0;

export const registerLoaderSetter = (setter) => {
  setLoadingFunc = setter;
};

const showLoader = () => {
  if (setLoadingFunc) setLoadingFunc(true);
};

const hideLoader = () => {
  if (setLoadingFunc) setLoadingFunc(false);
};

export const incrementLoader = () => {
  activeRequests++;
  showLoader();
};

export const decrementLoader = () => {
  activeRequests--;
  if (activeRequests <= 0) {
    activeRequests = 0;
    hideLoader();
  }
};
